export default __webpack_public_path__ + "static/media/silver.7d3c1642.svg";